import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  expense_head_id: "",
  month_year: dayjs().format("YYYY-MM"),
};

const expenseFilterSlice = createSlice({
  name: "expenseFilter",
  initialState,
  reducers: {
    setExpenseFilter: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetExpenseFilter: () => initialState,
  },
});

export const { setExpenseFilter, resetExpenseFilter } = expenseFilterSlice.actions;
export default expenseFilterSlice.reducer;
